/* WWC Hero
   HTML: sections/ss-hero-30.liquid
   CSS: assets/custom.css
   Runs only when [data-wwc-hero] exists.
*/

/* WWC Hero video lazyload */
(function(){
  function initWWCHeroMedia(){
    var items = document.querySelectorAll('[data-wwc-hero-src]');
    if (!items.length) return;

    function load(el){
      if (el.dataset.wwcHeroLoaded === '1') return;
      el.dataset.wwcHeroLoaded = '1';
      el.setAttribute('src', el.dataset.wwcHeroSrc);

      if (el.tagName === 'VIDEO') {
        el.load();
        el.play().catch(function(){});
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting) {
            load(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '350px' });

      items.forEach(function(el){ io.observe(el); });
    } else {
      items.forEach(load);
    }
  }

  document.addEventListener('DOMContentLoaded', initWWCHeroMedia);
  document.addEventListener('shopify:section:load', initWWCHeroMedia);
})();

/* ==================================================
   WWC Main Image Cards
   CSS: assets/custom.css
================================================== */

(function () {
  function toBool(value) {
    return String(value) === 'true';
  }

  function toNum(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function initImageCards(root) {
    if (!root || root.dataset.wwcImageCardsInited === '1') return;
    if (!window.Swiper) return;

    root.dataset.wwcImageCardsInited = '1';

    var forceSlider = toBool(root.dataset.forceSlider);
    var showTabs = toBool(root.dataset.showTabs);
    var tabCount = toNum(root.dataset.tabCount, 0);
    var centerWhenFew = toBool(root.dataset.centerWhenFew);
    var enableLightbox = toBool(root.dataset.enableLightbox);

    var perMobile = toNum(root.dataset.perMobile, 1);
    var perTablet = toNum(root.dataset.perTablet, 2);
    var perDesktop = toNum(root.dataset.perDesktop, 3);

    var swiperEl = root.querySelector('.ab-slider-swiper');
    if (!swiperEl) return;

    var swiper = new window.Swiper(swiperEl, {
      slidesPerView: perMobile,
      spaceBetween: 12,
      centeredSlides: perMobile === 1,
      breakpoints: {
        750: { slidesPerView: perTablet, spaceBetween: 12, centeredSlides: false },
        1024: { slidesPerView: perDesktop, spaceBetween: 24, centeredSlides: false }
      },
      navigation: {
        nextEl: root.querySelector('.ab-slider-next'),
        prevEl: root.querySelector('.ab-slider-prev')
      }
    });

    if (showTabs && tabCount > 1) {
      var tabWrapper = root.querySelector('.ab-slider-tab-wrapper');
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.ab-slider-tab'));
      var slides = Array.prototype.slice.call(root.querySelectorAll('.ab-slider-swiper .swiper-slide'));
      var desktopSlides = Array.prototype.slice.call(root.querySelectorAll('[data-ab-desktop-slide]'));
      var indicator = root.querySelector('.ab-slider-tab-indicator');
      var indicatorBg = root.querySelector('.ab-slider-tab-indicator-bg');

      tabs.forEach(function (button) {
        button.addEventListener('click', function () {
          if (window.innerWidth < 1024) {
            button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }

          var target = root.querySelector('.ab-slider-swiper .swiper-slide[data-tab="' + button.dataset.tab + '"]');

          if (target) {
            swiper.slideTo(parseInt(target.dataset.swiperSlideIndex || '0', 10));
          }

          desktopSlides.forEach(function (slide) {
            slide.classList.toggle('ab-slider-slide--desktop-active', slide.dataset.tab === button.dataset.tab);
          });

          updateActiveFromTab(button.dataset.tab);
        });
      });

      function updateActiveFromTab(activeTab) {
        tabs.forEach(function (button) {
          var isActive = button.dataset.tab === activeTab;
          button.classList.toggle('ab-slider-tab--active', isActive);

          if (isActive && indicator) {
            indicator.style.width = button.offsetWidth + 'px';
            indicator.style.transform = 'translateX(' + button.offsetLeft + 'px)';
          }
        });
      }

      function updateActiveFromSlide() {
        var active = slides[swiper.activeIndex];
        var activeTab = active && active.dataset ? active.dataset.tab : null;

        if (!activeTab) return;

        updateActiveFromTab(activeTab);

        var activeButton = root.querySelector('.ab-slider-tab--active');

        if (activeButton && window.innerWidth < 1024) {
          activeButton.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }

      function updateIndicatorBg() {
        if (!indicatorBg || !tabWrapper) return;
        indicatorBg.style.width = tabWrapper.offsetWidth + 'px';
      }

      swiper.on('slideChange', updateActiveFromSlide);

      window.addEventListener('resize', function () {
        var active = root.querySelector('.ab-slider-tab--active');

        if (active && indicator) {
          indicator.style.width = active.offsetWidth + 'px';
          indicator.style.transform = 'translateX(' + active.offsetLeft + 'px)';
        }

        updateIndicatorBg();
      });

      setTimeout(function () {
        var active = root.querySelector('.ab-slider-tab--active');

        if (active && indicator) {
          indicator.style.width = active.offsetWidth + 'px';
          indicator.style.transform = 'translateX(' + active.offsetLeft + 'px)';
        }

        updateIndicatorBg();
      }, 300);
    }

    if (forceSlider) {
      swiperEl.style.display = 'block';
    }

    function getPerView() {
      if (window.innerWidth >= 1024) return perDesktop;
      if (window.innerWidth >= 750) return perTablet;
      return perMobile;
    }

    function updateNavNeeded() {
      var total = root.querySelectorAll('.ab-slider-swiper .swiper-slide').length;
      var per = getPerView();

      if (total <= per) {
        root.classList.add('no-nav');

        if (centerWhenFew) {
          root.classList.add('center-few');
        } else {
          root.classList.remove('center-few');
        }
      } else {
        root.classList.remove('no-nav');
        root.classList.remove('center-few');
      }
    }

    swiper.on('resize', updateNavNeeded);
    swiper.on('update', updateNavNeeded);
    swiper.on('slideChange', updateNavNeeded);
    window.addEventListener('resize', updateNavNeeded);
    updateNavNeeded();

    if (enableLightbox) {
      setupLightbox(root);
    }
  }

  function setupLightbox(root) {
    var dialog = root.querySelector('.wwc-image-cards-lightbox');
    var dialogImg = dialog ? dialog.querySelector('img') : null;
    var closeBtn = dialog ? dialog.querySelector('.wwc-close') : null;

    function openWithMotion(fullSrc) {
      try {
        if (window.theme && typeof window.theme.openLightbox === 'function') {
          window.theme.openLightbox(fullSrc);
          return true;
        }

        var event = new CustomEvent('photoswipe:open', {
          detail: { items: [{ src: fullSrc }] }
        });

        window.dispatchEvent(event);
        return false;
      } catch (error) {
        return false;
      }
    }

    function openFallback(fullSrc) {
      if (!dialog || !dialogImg) return;

      dialogImg.src = fullSrc;

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    }

    if (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dialog.close();
      });
    }

    root.querySelectorAll('.ab-slider-slide').forEach(function (slide) {
      var hasLink = slide.getAttribute('data-has-link') === 'true';
      var fullSrc = slide.getAttribute('data-image-full');
      var img = slide.querySelector('.ab-slider-image');

      if (!img || hasLink || !fullSrc) return;

      img.style.cursor = 'zoom-in';
      img.setAttribute('role', 'button');
      img.setAttribute('tabindex', '0');

      var handler = function (event) {
        event.preventDefault();
        event.stopPropagation();

        var usedMotion = openWithMotion(fullSrc);
        if (!usedMotion) openFallback(fullSrc);
      };

      img.addEventListener('click', handler);

      img.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          handler(event);
        }
      });
    });
  }

  function initAllImageCards() {
    document.querySelectorAll('[data-wwc-image-cards]').forEach(initImageCards);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllImageCards);
  } else {
    initAllImageCards();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAllImageCards);
  }
})();

/* WWC Logo Cloud
   HTML: sections/ss-scrolling-logo-cloud.liquid
   CSS: assets/custom.css
   Runs only when [data-wwc-logo-cloud] exists.
*/
(function () {
  function initLogoCloud() {
    document.querySelectorAll('[data-wwc-logo-cloud]').forEach(function (root) {
      if (root.dataset.inited === '1') return;
      root.dataset.inited = '1';

      var track = root.querySelector('[data-wwc-logo-cloud-track]');
      if (!track || !track.parentNode) return;

      var clones = Number(root.dataset.clones || 6);
      if (!Number.isFinite(clones) || clones < 1) clones = 6;

      for (var i = 0; i < clones; i += 1) {
        var clone = track.cloneNode(true);
        clone.removeAttribute('data-wwc-logo-cloud-track');
        clone.setAttribute('aria-hidden', 'true');
        track.parentNode.appendChild(clone);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLogoCloud);
  } else {
    initLogoCloud();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initLogoCloud);
  }
})();

/* WWC Footer
   HTML: sections/ss-footer-scrolling.liquid
   CSS: assets/custom.css
   Runs only when [data-wwc-footer] exists.
*/
(function () {
  function initWWCFooter(root) {
    const footers = root.querySelectorAll('[data-wwc-footer]');

    footers.forEach(function (footer) {
      if (footer.dataset.wwcFooterReady === 'true') return;
      footer.dataset.wwcFooterReady = 'true';

      const thanksText = footer.querySelector('[data-footer-newsletter-thanks]');
      const submitButton = footer.querySelector('[data-footer-newsletter-submit]');

      if (window.location.search.includes('customer_posted=true')) {
        if (thanksText) thanksText.classList.add('is-active');
        if (submitButton) submitButton.setAttribute('disabled', 'true');
      }

      const answerPaddingTop = Number(footer.dataset.answerPaddingTop || 16);
      const toggles = footer.querySelectorAll('[data-footer-toggle]');
      const panels = footer.querySelectorAll('[data-footer-panel]');
      const heightPanels = footer.querySelectorAll('[data-footer-height-panel]');
      const icons = footer.querySelectorAll('[data-footer-icon]');

      let activeIndex = -1;

      function openPanel(index) {
        const panel = panels[index];
        const heightPanel = heightPanels[index];
        const icon = icons[index];

        if (!panel || !heightPanel) return;

        closeAllExcept(index);

        panel.style.display = 'block';

        requestAnimationFrame(function () {
          panel.style.height = heightPanel.offsetHeight + answerPaddingTop + 'px';
          panel.style.paddingTop = answerPaddingTop + 'px';
        });

        if (icon) icon.classList.add('is-active');

        const toggle = toggles[index];
        if (toggle) toggle.setAttribute('aria-expanded', 'true');

        activeIndex = index;
      }

      function closePanel(index) {
        const panel = panels[index];
        const icon = icons[index];
        const toggle = toggles[index];

        if (!panel) return;

        panel.style.height = '0px';
        panel.style.paddingTop = '0px';

        window.setTimeout(function () {
          if (panel.style.height === '0px') {
            panel.style.display = 'none';
          }
        }, 250);

        if (icon) icon.classList.remove('is-active');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');

        if (activeIndex === index) activeIndex = -1;
      }

      function closeAllExcept(index) {
        panels.forEach(function (_, panelIndex) {
          if (panelIndex !== index) closePanel(panelIndex);
        });
      }

      toggles.forEach(function (toggle, index) {
        toggle.addEventListener('click', function () {
          const panel = panels[index];
          const isOpen = panel && panel.style.display === 'block';

          if (isOpen) {
            closePanel(index);
          } else {
            openPanel(index);
          }
        });
      });

      let resizeTimer;

      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);

        resizeTimer = window.setTimeout(function () {
          if (activeIndex === -1) return;

          const panel = panels[activeIndex];
          const heightPanel = heightPanels[activeIndex];

          if (!panel || !heightPanel) return;

          panel.style.height = heightPanel.offsetHeight + answerPaddingTop + 'px';
        }, 200);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initWWCFooter(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initWWCFooter(event.target);
  });
})();


/*
  WWC Feature Icons V2
  - Mobile Swiper only
  - Desktop grid
  - Safe in Shopify Theme Editor
*/

(function () {
  const SELECTOR = '[data-wwc-feature-icons]';
  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

  function waitForSwiper(callback, tries = 0) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    if (tries > 30) return;

    window.setTimeout(function () {
      waitForSwiper(callback, tries + 1);
    }, 100);
  }

  function equalizeTitles(section) {
    const titles = section.querySelectorAll('[data-wwc-feature-title]');
    if (!titles.length) return;

    titles.forEach(function (title) {
      title.style.height = 'auto';
    });

    if (window.innerWidth < 750) return;

    const maxHeight = Math.max.apply(
      null,
      Array.from(titles).map(function (title) {
        return title.offsetHeight;
      })
    );

    titles.forEach(function (title) {
      title.style.height = maxHeight + 'px';
    });
  }

  function initSection(section) {
    const slider = section.querySelector('[data-wwc-feature-slider]');
    const pagination = section.querySelector('[data-wwc-feature-pagination]');
    const stackMobile = section.dataset.stackMobile === 'true';

    if (!slider) return;

    if (!MOBILE_QUERY.matches || stackMobile) {
      if (slider.wwcSwiper) {
        slider.wwcSwiper.destroy(true, true);
        slider.wwcSwiper = null;
      }

      equalizeTitles(section);
      return;
    }

    waitForSwiper(function () {
      if (slider.wwcSwiper) return;

      slider.wwcSwiper = new Swiper(slider, {
        slidesPerView: 1,
        loop: section.querySelectorAll('.swiper-slide').length > 1,
        speed: 450,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 4500,
          disableOnInteraction: false
        },
        pagination: pagination
          ? {
              el: pagination,
              clickable: true
            }
          : false
      });

      equalizeTitles(section);
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('resize', initAll);

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(initAll, 50);
  });
})();


/* =========================================================
   WWC - Video with text
   File: assets/wwc-video-with-text.js
========================================================= */

(function () {
  function initVideoWithText(root) {
    const scope = root || document;
    const sections = scope.querySelectorAll('[data-wwc-video-with-text]');

    sections.forEach(function (section) {
      if (section.dataset.wwcVwtInit === '1') return;
      section.dataset.wwcVwtInit = '1';

      const poster = section.querySelector('.wwc-vwt__poster-button');
      const play = section.querySelector('.wwc-vwt__play');
      const iframe = section.querySelector('.wwc-vwt__iframe');
      const video = section.querySelector('.wwc-vwt__video');

      function startVideo() {
        if (iframe && !iframe.getAttribute('src')) {
          const src = iframe.getAttribute('data-src');

          if (src) {
            const joiner = src.indexOf('?') > -1 ? '&' : '?';
            iframe.setAttribute('src', src + joiner + 'autoplay=1&mute=1');
          }
        }

        if (video) {
          video.play().catch(function () {});
        }

        if (poster) poster.classList.add('is-hidden');
        if (play) play.classList.add('is-hidden');
      }

      if (poster) {
        poster.addEventListener('click', startVideo);
      }

      if (play) {
        play.addEventListener('click', startVideo);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initVideoWithText(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initVideoWithText(event.target);
  });
})();